import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import Button from "components/atoms/Button";
import InputField from "components/atoms/InputField";
import InputSelect from "components/atoms/InputSelect";
import { toOption } from "pages/MasterPengobatanStandar/constants";
import { errorMessages } from "services/StandardTreatment";

export const RULE_MODAL_ID = "ruleFormModal";

const STATUS_OPTIONS = [
  { label: "Aktif", value: true },
  { label: "Nonaktif", value: false },
];
const EMPTY = {
  source_rule_code: "",
  source_rule_seq: "1",
  name: "",
  priority: "0",
  is_active: true,
  clinical_note: "",
  change_note: "",
};

// Field mengikuti RuleCreate / RuleUpdate (openapi.yaml). Hanya untuk Versi DRAFT.
const RuleFormModal = ({ mode, rule, onSubmit }) => {
  const [serverErrors, setServerErrors] = useState([]);
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: rule
      ? {
          ...EMPTY,
          ...rule,
          source_rule_seq: String(rule.source_rule_seq),
          priority: String(rule.priority),
          clinical_note: rule.clinical_note || "",
          change_note: rule.change_note || "",
        }
      : EMPTY,
    validationSchema: Yup.object({
      source_rule_code: Yup.string().trim().max(20, "Maksimal 20 karakter").required("Kode rule wajib diisi"),
      source_rule_seq: Yup.number().typeError("Harus angka").integer().min(1, "Minimal 1").required("Wajib diisi"),
      name: Yup.string().trim().max(255).required("Nama rule wajib diisi"),
      priority: Yup.number().typeError("Harus angka").integer().min(0, "Minimal 0"),
    }),
    onSubmit: (v) => {
      setServerErrors([]);
      return onSubmit({
        source_rule_code: v.source_rule_code.trim().toUpperCase(),
        source_rule_seq: Number(v.source_rule_seq),
        name: v.name.trim(),
        priority: Number(v.priority || 0),
        is_active: v.is_active,
        clinical_note: v.clinical_note.trim() || null,
        change_note: v.change_note.trim() || null,
      }).catch((err) => setServerErrors(errorMessages(err)));
    },
  });

  const fieldProps = (key) => ({
    ...formik.getFieldProps(key),
    error: formik.touched[key] && formik.errors[key],
    errorMessage: formik.errors[key],
  });

  return (
    <div className="modal fade md-modal" id={RULE_MODAL_ID} tabIndex={-1} aria-labelledby={`${RULE_MODAL_ID}Label`} aria-hidden="true">
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id={`${RULE_MODAL_ID}Label`}>
              {mode === "edit" ? "Edit Rule" : "Tambah Rule"}
            </h5>
            <button type="button" className="close" data-dismiss="modal" aria-label="Tutup">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <form onSubmit={formik.handleSubmit} noValidate>
            <div className="modal-body">
              {serverErrors.length > 0 && (
                <div className="mps-alert is-error" role="alert">
                  <ul className="mps-alert-list mt-0">
                    {serverErrors.map((m) => (
                      <li key={m}>{m}</li>
                    ))}
                  </ul>
                </div>
              )}
              <div className="row">
                <div className="col-6 col-md-3 md-field">
                  <InputField label="Kode rule" isRequired placeholder="A18" maxLengthVal={20} {...fieldProps("source_rule_code")} />
                </div>
                <div className="col-6 col-md-3 md-field">
                  <InputField label="Split (seq)" isRequired type="number" {...fieldProps("source_rule_seq")} />
                </div>
                <div className="col-6 col-md-3 md-field">
                  <InputField label="Prioritas" type="number" {...fieldProps("priority")} />
                </div>
                <div className="col-6 col-md-3 md-field">
                  <InputSelect
                    label="Status"
                    isClearable={false}
                    data={STATUS_OPTIONS}
                    value={toOption(STATUS_OPTIONS, formik.values.is_active)}
                    onChange={(sel) => formik.setFieldValue("is_active", sel?.value ?? true)}
                  />
                </div>
              </div>
              <p className="mps-helper mt-0 mb-3">
                Kode & split berasal dari workbook kebijakan (A2 punya 3 split, A18 punya 2). Prioritas
                hanya disimpan — evaluasi tidak memakainya. Rule nonaktif dilewati saat evaluasi.
              </p>
              <div className="md-field">
                <InputField label="Nama rule" isRequired placeholder="A18 — Falciparum, tanpa komplikasi, di atas 8 tahun" {...fieldProps("name")} />
              </div>
              <div className="row">
                <div className="col-md-6 md-field">
                  <InputField type="textarea" label="Catatan klinis (clinical_note)" {...fieldProps("clinical_note")} />
                </div>
                <div className="col-md-6 md-field">
                  <InputField type="textarea" label="Catatan perubahan (change_note)" {...fieldProps("change_note")} />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <Button type="button" variant="secondary" size="normal" data-dismiss="modal">
                Batal
              </Button>
              <Button type="submit" variant="primary" size="normal" isDisabled={formik.isSubmitting}>
                {formik.isSubmitting ? "Menyimpan..." : "Simpan"}
              </Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default RuleFormModal;
